import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import NProgress from "nprogress";
import "nprogress/nprogress.css";
// import zhLocale from 'element-plus/lib/locale/lang/zh-cn'
// 引入控制台模拟插件
import Terminal from 'vue-web-terminal'

import { setupRouter } from "@/router";

const temp = "null";

// 引入字体
//import "./assets/fonts/fonts.css";
// 第三方包
import ElementPlus from "element-plus";
import zhCn from "element-plus/es/locale/lang/zh-cn";

import "element-plus/lib/theme-chalk/index.css";
// import "element-plus/theme-chalk/index.css";
import JsonViewer from "vue3-json-viewer";
import Vue3Cron from 'vue3-cron'
import 'vue3-cron/lib/vue3Cron.css' 

import axios from "axios";
// app.config.globalProperties.$axios=axios;

const app = createApp(App);

// 使用控制台模拟插件
app.use(Terminal);

// 引入全局变量
app.config.globalProperties.$g_version = "1.0.18";

//版本更新日期：2021.12.17  15:07

NProgress.configure({
  easing: "ease",
  speed: 500,
  showSpinner: false,
  trickleSpeed: 200,
  minimum: 0.3,
});

//路由监听
// router.beforeEach((to, from, next) => {
//     NProgress.start();
//     next();
// });
//路由跳转结束
// router.afterEach(() => {
//     NProgress.done()
// })

Date.prototype.format = function(format) {
  var date = {
    "M+": this.getMonth() + 1,
    "d+": this.getDate(),
    "h+": this.getHours(),
    "m+": this.getMinutes(),
    "s+": this.getSeconds(),
    "q+": Math.floor((this.getMonth() + 3) / 3),
    "S+": this.getMilliseconds(),
  };
  if (/(y+)/i.test(format)) {
    format = format.replace(
      RegExp.$1,
      (this.getFullYear() + "").substr(4 - RegExp.$1.length)
    );
  }
  for (var k in date) {
    if (new RegExp("(" + k + ")").test(format)) {
      format = format.replace(
        RegExp.$1,
        RegExp.$1.length == 1
          ? date[k]
          : ("00" + date[k]).substr(("" + date[k]).length)
      );
    }
  }
  return format;
};

setupRouter(app);

app
  .use(store)
  .use(router)
  .use(ElementPlus, { locale: zhCn })
  .use(JsonViewer)
  .use(Vue3Cron)
  .mount("#app");
